//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

export default {
	name: "Loader",
	data() {
		return {
			errorText: this.$root.loadError
		}
	},
	computed: {
		...mapGetters(["loading", "error"]),
	}
}
